export default [
  'child_seats_infant',
  'child_seats_convertible',
  'child_seats_booster',
];
